import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TEAM_SEGMENT_OPTIONS } from "./mockData";
import type { TeamSegment } from "./types";
import { SegmentPills } from "../shared/SegmentPills";

interface TeamSegmentPillsProps {
  value: TeamSegment;
  onChange: (value: TeamSegment) => void;
}

export const TeamSegmentPills = memo(function TeamSegmentPills({
  value,
  onChange,
}: TeamSegmentPillsProps) {
  const { t } = useTranslation();

  const options = useMemo(
    () =>
      TEAM_SEGMENT_OPTIONS.map((option) => ({
        value: option.value,
        label: t(`analytics.team.segments.${option.value}`, option.label),
      })),
    [t],
  );

  return (
    <SegmentPills
      value={value}
      options={options}
      onChange={onChange}
      ariaLabel={t("analytics.aria.teamSegments", "Team segments")}
    />
  );
});
